import { Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { ApiKeysSection } from '../../components/ApiKeysSection';

export const Page = () => {
  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>API Keys</Typography>
      <ApiKeysSection />
    </Stack>
  );
};

export const Route = createFileRoute('/api-keys/')({
  component: Page
});
